import "./style.css";
import { useState, useEffect } from "react"
import TitleBar from "../../layout/TitleBar"
import Layout from "../../layout/Layout"
import {
  getIndividualUsers
} from "../../../actions/admin/user";
import { Link } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { useLoading } from "../../LoadingContext"
import { ON_GET_INDIVIDUAL_USER } from "../../../actions/types";
import ConfirmationModal from "../components/ConfirmationModal"
import useConfirmation from "../components/useConfirmation"
import ModalSuccess from "../../modal/ModalSuccess"
import Spinner from "../../layout/Spinner";
import AccountInformation from "./_components/AccountInformation"
import BillingInformation from "./_components/BillingInformation"
import PaymentMethod from "./_components/PaymentMethod"
import { BackAltIcon } from "../../icons";

const IndividualDetail = ({ match }) => {
  const dispatch = useDispatch()
  const individualuser = useSelector((state) => state.individualuser);
  const { loading, individualUsers } = individualuser;
  const { confirmationProps } = useConfirmation()
  const [showModalSuccess, setShowModalSuccess] = useState(false);
  const [modalSuccessContent, setModalSuccessContent] = useState({
    title: "",
    desc: ""
  })

  useEffect(() => {
    dispatch({
      type: ON_GET_INDIVIDUAL_USER,
    });
    const handler = setTimeout(() => {
      dispatch(getIndividualUsers({
        sortBy: "asc",
        orderBy: "date",
        page: 1,
        limit: 1,
        disableCalculateTotal: false,
        draw: 1,
        id: match?.params?.id,
      }));
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [dispatch]);

  console.log(individualUsers)

  const handleCloseModalSuccess = () => {
    setShowModalSuccess(false)
    setModalSuccessContent({
      title: "",
      desc: ""
    })
  }

  const getAccountStatus = () => {
    if (loading) return {
      style: "",
      text: ""
    };

    switch (individualUsers?.data[0]?.status) {
      case "PENDING_VERIFICATION":
        return {
          style: "badge badge-pending-verif",
          text: "Pending Verification"
        }
        break;

      case "ACTIVE":
        return {
          style: "badge badge-approved",
          text: "Approved"
        }
        break;

      case "DEACTIVE":
        return {
          style: "badge badge-rejected",
          text: "Deactive"
        }
        break;

      default:
        break;
    }
  }

  return (
    <Layout>
      <ConfirmationModal {...confirmationProps} />
      <ModalSuccess
        handleClose={handleCloseModalSuccess}
        show={showModalSuccess}
        title={modalSuccessContent.title}
        desc={modalSuccessContent.desc}
      />
      <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4 w-100">
        <div className="container-fluid mb-5">
          <div className="row d-flex align-items-center justify-content-between mt-3 py-3">
            <div className="col d-flex align-items-center justify-content-start gap-3">
              <Link to={`/admin/userlist-individual`}>
                <BackAltIcon />
              </Link>
              <h4 className="m-0">
                {
                  !loading && (
                    individualUsers?.data[0]?.name
                  )
                }
              </h4>
            </div>
            <div className="col d-flex align-items-center justify-content-end gap-2">
              <div className={getAccountStatus().style}>{getAccountStatus().text}</div>
            </div>
          </div>

          {
            loading ? (
              <div className="container-fluid mb-5 tw:!mt-8">
                <Spinner />
              </div>
            ) : (
              <>
                <AccountInformation
                  loading={loading}
                  data={individualUsers?.data[0]}
                />

                <hr className="hr-grey-account p-0 m-0" />

                <BillingInformation
                  loading={loading}
                  data={individualUsers?.data[0]}
                />

                <hr className="hr-grey-account p-0 m-0" />

                <PaymentMethod
                  loading={loading}
                  data={individualUsers?.data[0]}
                />

                {/* <div className="row d-flex align-items-center justify-content-between mt-3 py-3">
                  <div className="col d-flex align-items-center justify-content-end gap-2">
                    {
                      individualUsers?.data[0]?.status === "ACTIVE" && individualUsers?.data[0]?.role === "individual" && (
                        <button
                          className="btn btn-deactive-account"
                        >
                          <div className="d-flex align-items-center justify-content-center gap-1">
                            Deactivate Account
                          </div>
                        </button>
                      )
                    }
                  </div>
                </div> */}
              </>
            )
          }
        </div>
      </main>
    </Layout >
  )
}

export default IndividualDetail;

